import React from 'react'
import { motion } from 'framer-motion'
import { Filter, BarChart3, Search, ArrowRight } from 'lucide-react'

const steps = [
  { icon: Filter, title: 'Filtrez', desc: 'Produits, importateurs ou fournisseurs', color: 'blue' },
  { icon: BarChart3, title: 'Analysez', desc: 'KPI, tendances et classements', color: 'emerald' },
  { icon: Search, title: 'Explorez', desc: 'Données détaillées et export', color: 'violet' },
]

const colorMap = {
  blue: 'bg-blue-50 dark:bg-blue-950/30 text-blue-600 dark:text-blue-400',
  emerald: 'bg-emerald-50 dark:bg-emerald-950/30 text-emerald-600 dark:text-emerald-400',
  violet: 'bg-violet-50 dark:bg-violet-950/30 text-violet-600 dark:text-violet-400',
}

const EmptyState = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center py-16 sm:py-20"
    >
      <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center shadow-lg shadow-primary-500/20 mb-6">
        <BarChart3 className="w-8 h-8 text-white" />
      </div>
      
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
        Bienvenue sur TradeScope
      </h3>
      
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-10 max-w-sm mx-auto">
        Sélectionnez des filtres pour explorer vos données d'import/export.
      </p>
      
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-3 max-w-2xl mx-auto">
        {steps.map((step, i) => (
          <React.Fragment key={step.title}>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + i * 0.15 }}
              className="card-sm w-full sm:w-48 text-center"
            >
              <div className={`inline-flex items-center justify-center w-10 h-10 rounded-xl ${colorMap[step.color]} mb-3`}>
                <step.icon className="w-5 h-5" />
              </div>
              <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-1">
                {i + 1}. {step.title}
              </h4>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {step.desc}
              </p>
            </motion.div>
            {i < steps.length - 1 && (
              <ArrowRight className="hidden sm:block w-4 h-4 text-gray-300 dark:text-gray-600 flex-shrink-0" />
            )}
          </React.Fragment>
        ))}
      </div>
    </motion.div>
  )
}

export default EmptyState
